export default function CTASection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="px-6 md:px-12 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
          Ready to Order?
        </h2>
        <p className="mt-3 text-foreground-600 text-sm md:text-base">
          Get the best deals on kaspreadsheet.com
        </p>

        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 mt-6 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          buy it now
          <i className="ri-arrow-right-line"></i>
        </a>

        <div className="mt-12 w-full h-48 md:h-64 rounded-xl overflow-hidden bg-background-100">
          <img
            src="https://readdy.ai/api/search-image?query=A%20wide%20horizontal%20editorial%20banner%20showcasing%20an%20elegant%20arrangement%20of%20lifestyle%20products%20including%20tan%20leather%20accessories%20cream%20knitwear%20a%20silver%20watch%20and%20designer%20sneakers%20laid%20out%20in%20a%20row%20on%20a%20warm%20sand%20colored%20surface%20with%20soft%20natural%20lighting%20from%20large%20windows%2C%20editorial%20product%20photography%2C%20clean%20minimal%20composition%2C%20warm%20neutral%20tone&width=1600&height=600&seq=cta-banner-v2-products&orientation=landscape"
            alt="Superbuy products collection"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}